<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" width="20.983"
    height="20.331" viewBox="0 0 20.983 20.331"
  >
    <g data-name="그룹 219">
      <g data-name="그룹 221" style="clip-path:url(#6kk15ejela)">
        <path
          data-name="패스 464"
          d="M12.531 13.377a.5.5 0 0 1-.492.508H9.023V5.266a1.033 1.033 0 0 0-.542-.9L3.929 2.032h8.094a.5.5 0 0 1 .508.492v.4L14.562.892V.858C14.56.3 14.107 0 13.547 0H1.016A1.02 1.02 0 0 0 0 1.016v14.359a1.035 1.035 0 0 0 .542.9l7.721 4a.513.513 0 0 0 .745-.458v-3.9h4.538a1.018 1.018 0 0 0 1.016-1.017v-1.965L12.531 10.9z"
        />
        <path
          data-name="패스 465"
          d="m14.188 10.911-3.3-3.3a1.012 1.012 0 0 1-.042-1.431l.042-.042 3.3-3.3a1.033 1.033 0 0 1 1.46-.047l.031.03a1.08 1.08 0 0 1-.034 1.49l-1.49 1.473h5.774a1 1 0 0 1 .762.339 1.151 1.151 0 0 1-.091 1.624 1.207 1.207 0 0 1-.163.121 1.089 1.089 0 0 1-.508.132h-5.774s1.473 1.473 1.491 1.473a1.025 1.025 0 1 1-1.458 1.435"
        />
      </g>
    </g>
  </svg>
</template>